import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import AnnouncementBanner from '../helper/Banner/AnnouncementBanner';
import logo from '../../images/ttms_logo_1.png';
import fleet from '../../images/auth_fleet.webp';
import cab from '../../images/auth_cab.webp';
import './auth.css';

/**
 * Shell for every sign-in style screen: dark brand panel with the fleet on
 * one side, the form on the other (stacked as a band + sheet on phones).
 *
 * brand: { eyebrow, title, text, highlights: [{ icon: Component, label }] }
 */
export default function AuthLayout({ bannerRole, brand, back = { to: '/', label: 'Home' }, children }) {
    return (
        <div className="ta">
            {bannerRole && (
                <div className="ta-banner">
                    <AnnouncementBanner role={bannerRole} />
                </div>
            )}

            <aside className="ta-brand">
                <Link to="/" className="ta-brand-logo" aria-label="Triple Trans Mill Services — home">
                    <img src={logo} alt="Triple Trans Mill Services Ltd." />
                </Link>

                <div className="ta-brand-copy">
                    {brand.eyebrow && <p className="ta-brand-eyebrow">{brand.eyebrow}</p>}
                    <h1 className="ta-brand-title">{brand.title}</h1>
                    {brand.text && <p className="ta-brand-text">{brand.text}</p>}
                    {brand.highlights && (
                        <ul className="ta-brand-highlights">
                            {brand.highlights.map(({ icon: Icon, label }) => (
                                <li key={label}><Icon size={15} aria-hidden="true" />{label}</li>
                            ))}
                        </ul>
                    )}
                </div>

                <picture className="ta-brand-art">
                    <source media="(min-width: 600px)" srcSet={fleet} />
                    <img src={cab} alt="" />
                </picture>
            </aside>

            <main className="ta-panel">
                <div className="ta-panel-top">
                    {back && (
                        <Link to={back.to} className="ta-back">
                            <FiArrowLeft size={16} aria-hidden="true" /> {back.label}
                        </Link>
                    )}
                </div>
                <div className="ta-form-wrap">
                    <div className="ta-form">{children}</div>
                </div>
                <p className="ta-legal">© {new Date().getFullYear()} Triple Trans Mill Services Ltd.</p>
            </main>
        </div>
    );
}
